
<div class="flex w-full h-full">
    

    <div id="sideMenu" class="shadow-2 w-4rem h-full flex mr-4 surface-section flex-column align-items-start" [ngClass]="(claimTrayOpen$ | async) ? 'min-w-min' : '' ">
        <div class="border-top-1 surface-border p-3 w-full flex justify-content-end column-gap-5">
            <p-button pRipple icon="pi pi-bars" styleClass="w-2rem h-2rem"  (click)="toggleClaimTray($event)"></p-button>

        </div>
        <app-claim-sidecar class="w-full flex"></app-claim-sidecar>
    </div>
    <div class="flex ml-5 h-full">
        <p-tabView (onChange)="encounterSelected($event)" [activeIndex]="(activeIndex$ | async) ?? 0">
            <p-tabPanel *ngFor="let encounter of (openEncounters$ | async); let i = index" [selected]="(activeIndex$ | async) == i">
                <ng-template pTemplate="header">
                    <i class="pi pi-bars"></i>
                    <span class="pl-2">{{ encounter.id.toString() }} - </span><span class="pl-2">{{ encounter.referral.claim?.party?.firstName }}<br/>{{ encounter.referral.claim?.party?.lastName }}</span>
                    <p-button icon="pi pi-times" [text]="true" (onClick)="closeEncounter(encounter)" [style]="{'z-index': '1'}"></p-button>
                </ng-template>
                <div style="height:100%" class="overflow-y-scroll">
                    <app-encounter-editor [encounter]="(activeEncounter$ | async) ?? undefined"></app-encounter-editor>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>

</div>






